import React from "react";
import styles from "./NavLink.module.css";

/**
 * ナビゲーション用リンク
 * @param {object} props
 * @param {string} props.href - リンク先
 * @param {React.ReactNode} props.children - 表示内容
 * @param {function} [props.onClick] - クリック時のハンドラ
 * @param {string} [props.className] - 追加クラス
 * @param {boolean} [props.active] - アクティブ状態
 */
const NavLink = ({ href, children, onClick, className = "", active = false }) => (
  <a
    href={href}
    onClick={onClick}
    className={`${styles.link} ${className}${active && styles.activeLink ? ` ${styles.activeLink}` : ""}`.trim()}
  >
    {children}
  </a>
);

export default NavLink; 